import React, { Component } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { DotsVerticalRounded } from 'styled-icons/boxicons-regular';
import { Popup } from '@progress/kendo-react-popup';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import { IntlProvider, loadMessages, LocalizationProvider } from '@progress/kendo-react-intl';
import { ShowChart } from 'styled-icons/material';
import dayjs from 'dayjs';
import BarLoader from 'react-spinners/BarLoader';
import Grid from '@material-ui/core/Grid';
import { am4charts, am4core } from '../../../system/utils/amcharts';
import DownloadUsersReport from './excel/users';
import database from '../../../model/firebase/firebase';
import esMessages from '../../../system/utils/messagesSpanishKendo/es.json';
import { palette } from '../../../system/styles/styles';
import active from '../../../assets/img_1.png';
import registered from '../../../assets/linkedin.png';
import filed from '../../../assets/expediente.png';

function UsersDashboard(props) {
  const { className } = props;

  const [state, setState] = React.useState({
    vacancies: [],
    message: false,
    renderGraph: false,
    data: [],
    campusUsers: [],
    cvArrayCounter: [],
    activeCompanies: [],
    backupUsers: [],
    backupActive: [],
    backupCv: [],
    typeUser: 'all',
    carrer: 'all',
    campus: 'all',
    allTime: true,
    maxDate: null,
    minDate: null,
    openMenu: false,
  });

  const platform = useSelector((state) => state.platform);
  const users = useSelector((state) => state.users);

  loadMessages(esMessages, 'es'); // Le decimos que mensajes queremos por idioma
  const maxDate = new Date();

  const chart = React.useRef(null);
  const contentRef = React.useRef();
  const blurTimeoutRef = React.useRef();
  const anchorEl = React.useRef();

  const onFocus = () => {
    // the user is still inside the content
    clearTimeout(blurTimeoutRef.current);
  };

  const onBlurTimeout = () => {
    // the user is now outside the popup
    setState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const onBlur = () => {
    clearTimeout(blurTimeoutRef.current);
    blurTimeoutRef.current = setTimeout(onBlurTimeout, 200);
  };

  const updateAnalytics = async (e) => {
    const value = e;
    setState((prev) => ({
      ...prev,
      renderGraph: false,
    }));
    const data = await getAnalytics(value);
    setState((prev) => ({
      ...prev,
      renderGraph: true,
      data: [data.campusUsers.length, data.activeCompanies.length, data.cvArrayCounter.length],
    }));
  };

  const getAnalytics = async (campus) => {
    if (campus === 'all') {
      const newUser = users.reduce(
        (acc, element) => {
          if (element.status === 'authorized' && state.allTime) {
            acc.campusUsers.push(element);
            acc.backupUsers.push(element);
          }
          if (element.existCv || (element?.cvData && state.allTime)) {
            acc.cvArrayCounter.push(element);
            acc.backupCv.push(element);
          }
          if (element.lastLogin !== undefined && element.lastLogin !== '' && state.allTime) {
            acc.activeCompanies.push(element);
            acc.backupActive.push(element);
          }
          const evalDate = dayjs(element.authTime).isBetween(state.minDate, state.maxDate);
          if (element.status === 'authorized' && evalDate && !state.allTime) {
            acc.campusUsers.push(element);
            acc.backupUsers.push(element);
          }
          if (element.exists && evalDate && !state.allTime) {
            acc.cvArrayCounter.push(element);
            acc.backupCv.push(element);
          }
          if (evalDate && element.lastLogin !== undefined && element.lastLogin !== '' && evalDate && !state.allTime) {
            acc.activeCompanies.push(element);
            acc.backupActive.push(element);
          }
          return acc;
        },
        {
          campusUsers: [],
          backupUsers: [],
          cvArrayCounter: [],
          backupCv: [],
          activeCompanies: [],
          backupActive: [],
        }
      );
      setState((prev) => ({
        ...prev,
        campusUsers: newUser.campusUsers,
        backupUsers: newUser.backupUsers,
        cvArrayCounter: newUser.cvArrayCounter,
        backupCv: newUser.backupCv,
        activeCompanies: newUser.activeCompanies,
        backupActive: newUser.backupActive,
      }));
      return {
        campusUsers: newUser.campusUsers,
        backupUsers: newUser.backupUsers,
        cvArrayCounter: newUser.cvArrayCounter,
        backupCv: newUser.backupCv,
        activeCompanies: newUser.activeCompanies,
        backupActive: newUser.backupActive,
      };
    }
    const newObject = (
      await database
        .collection(`${platform.platformName}`)
        .doc('data')
        .collection('users')
        .where('campusSegment', '==', campus)
        .get()
    ).docs.reduce(
      (acc, element) => {
        const userData = element.data();
        // TODO: Creo esta mal considero que debe ser userData no element, pero as[i estaba
        const evalDateBetween = dayjs(element.authTime).isBetween(state.minDate, state.maxDate);
        if (state.allTime && userData.status === 'authorized') {
          acc.campusUsers.push(userData);
          acc.backupUsers.push(userData);
        }
        if (state.allTime && userData.existCv) {
          acc.campusUsers.push(userData);
          acc.backupUsers.push(userData);
        }
        const parseDate = parseInt(userData.lastLogin);
        const evalDate = dayjs(parseDate).month() - dayjs().month();
        if (
          state.allTime &&
          userData.lastLogin !== undefined &&
          userData.lastLogin !== '' &&
          evalDate <= 2 &&
          evalDate >= 0
        ) {
          acc.activeCompanies.push(userData);
          acc.backupActive.push(userData);
        }
        if (evalDateBetween && userData.status === 'authorized' && !state.allTime) {
          acc.campusUsers.push(userData);
          acc.backupUsers.push(userData);
        }
        if (evalDateBetween && (userData.existCv || element?.cvData) && !state.allTime) {
          acc.cvArrayCounter.push(userData);
          acc.backupCv.push(userData);
        }
        // TODO: Creo la siguiente linea esta mal, lo reescribi tal cual como en el original, pero estoy conevncido que esta mal.
        const evalDateLastLogin = dayjs(element.lastLogin).isBetween(state.minDate, state.maxDate);
        if (
          evalDateBetween &&
          !state.allTime &&
          userData.lastLogin !== undefined &&
          userData.lastLogin !== '' &&
          evalDateLastLogin
        ) {
          acc.activeCompanies.push(userData);
          acc.backupActive.push(userData);
        }
        return acc;
      },
      {
        campusUsers: [],
        backupUsers: [],
        cvArrayCounter: [],
        backupCv: [],
        activeCompanies: [],
        backupActive: [],
      }
    );
    setState((prev) => ({
      ...prev,
      campusUsers: newObject.campusUsers,
      backupUsers: newObject.backupUsers,
      cvArrayCounter: newObject.cvArrayCounter,
      backupCv: newObject.backupCv,
      activeCompanies: newObject.activeCompanies,
      backupActive: newObject.backupActive,
    }));
    return {
      campusUsers: newObject.campusUsers,
      backupUsers: newObject.backupUsers,
      cvArrayCounter: newObject.cvArrayCounter,
      backupCv: newObject.backupCv,
      activeCompanies: newObject.activeCompanies,
      backupActive: newObject.backupActive,
    };
  };

  const filterByElse = async () => {
    if (state.carrer === 'all' && state.typeUser === 'all') {
      setState((prev) => ({
        ...prev,
        renderGraph: true,
        data: [state.campusUsers.length, state.activeCompanies.length, state.cvArrayCounter.length],
      }));
    } else if (state.carrer === 'all' && state.typeUser !== 'all') {
      const typeValue = state.typeUser;
      const campusUsers = state.campusUsers.filter((job) => job.userType.includes(typeValue));
      const cvArrayCounter = state.cvArrayCounter.filter((job) => job.userType.includes(typeValue));
      const activeCompanies = state.activeCompanies.filter((job) => job.userType.includes(typeValue));
      setState((prev) => ({
        ...prev,
        data: [campusUsers.length, activeCompanies.length, cvArrayCounter.length],
        renderGraph: true,
      }));
    } else if (state.carrer !== 'all' && state.typeUser === 'all') {
      const typeCarrer = state.carrer;
      const campusUsers = state.campusUsers.filter((job) => job.career.includes(typeCarrer));
      const cvArrayCounter = state.cvArrayCounter.filter((job) => job.career.includes(typeCarrer));
      const activeCompanies = state.activeCompanies.filter((job) => job.career.includes(typeCarrer));
      setState((prev) => ({
        ...prev,
        data: [campusUsers.length, activeCompanies.length, cvArrayCounter.length],
        renderGraph: true,
      }));
    } else if (state.carrer !== 'all' && state.typeUser !== 'all') {
      const typeValue = state.typeUser;
      const typeCarrer = state.carrer;
      const campusUsers = state.campusUsers.filter(
        (job) => job.career.includes(typeCarrer) && job.userType.includes(typeValue)
      );
      const cvArrayCounter = state.cvArrayCounter.filter(
        (job) => job.career.includes(typeCarrer) && job.userType.includes(typeValue)
      );
      const activeCompanies = state.activeCompanies.filter(
        (job) => job.career.includes(typeCarrer) && job.userType.includes(typeValue)
      );
      setState((prev) => ({
        ...prev,
        data: [campusUsers.length, activeCompanies.length, cvArrayCounter.length],
        renderGraph: true,
      }));
    }
  };

  const handleClick = () => {
    setState((prev) => ({
      ...prev,
      open: !prev.open,
    }));
  };

  const handleCloseMenu = () => {
    setState((prev) => ({
      ...prev,
      anchorEl: null,
    }));
  };

  const onOpen = () => {
    contentRef.current.focus();
  };

  const effect = async () => {
    window.scrollTo(0, 0);
    const datos = await getAnalytics('all');
    setState((prev) => ({
      ...prev,
      data: [datos.campusUsers.length, datos.activeCompanies.length, datos.cvArrayCounter.length],
      renderGraph: true,
    }));
  };

  const changedRangeInputs = (e) => {
    const { end, start } = e.value;
    if (start) {
      setState((prev) => ({
        ...prev,
        minDate: start,
        allTime: false,
      }));
    }
    if (end) {
      setState((prev) => ({
        ...prev,
        maxDate: end,
        allTime: false,
      }));
    }
  };

  React.useEffect(() => {
    effect();
  }, []);

  React.useEffect(() => {
    const { minDate, maxDate } = state;
    if (minDate !== null && maxDate !== null) {
      updateAnalytics(state.campus);
    }
  }, [state.maxDate, state.minDate]);

  React.useEffect(() => {
    setState((prev) => ({
      ...prev,
      renderGraph: false,
    }));
    filterByElse();
  }, [state.typeUser, state.carrer]);

  React.useEffect(() => {
    updateAnalytics(state.campus);
  }, [state.campus]);

  React.useLayoutEffect(() => {
    const x = am4core.create('studients', am4charts.XYChart);
    x.data = [
      {
        category: 'Usuarios registrados',
        value: state.data?.[0] || 0,
      },
      {
        category: 'Usuarios activos',
        value: state.data?.[1] || 0,
      },
      {
        category: 'CVs agregados',
        value: state.data?.[2] || 0,
      },
    ];

    const categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'category';
    categoryAxis.title.text = '';
    categoryAxis.renderer.minGridDistance = 40;
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.cellStartLocation = 0.2;
    categoryAxis.renderer.cellEndLocation = 0.8;
    categoryAxis.renderer.minGridDistance = 30;

    const valueAxis = x.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = '';

    // Otra serie
    const series4 = x.series.push(new am4charts.ColumnSeries());
    series4.name = '{category}';
    series4.stroke = am4core.color(`${platform.adminColor ? platform.adminColor : '#0f3f44'}`);
    series4.strokeWidth = 3;
    series4.dataFields.valueY = 'value';
    series4.tooltipText = `{valueX}: [bold]{valueY}[/]`;
    series4.dataFields.categoryX = 'category';
    series4.smoothing = 'monotoneX';
    series4.columns.template.fill = am4core.color(`${platform.adminColor ? platform.adminColor : '#0f3f44'}`); // fill
    series4.columns.template.width = am4core.percent(60);

    // Cambia el color del background del tootip
    series4.tooltip.getFillFromObject = false;
    series4.tooltip.background.fill = am4core.color('#FFF');

    // Set text color
    series4.tooltip.label.fill = am4core.color('#000');

    const scrollbarX = new am4charts.XYChartScrollbar();
    scrollbarX.series.push(series4);
    scrollbarX.start = 0;
    scrollbarX.end = 0.08;
    x.scrollbarX = scrollbarX;

    // Add cursor
    x.cursor = new am4charts.XYCursor();

    chart.current = x;

    return () => {
      x.dispose();
    };
  }, [state.renderGraph, state.data]);

  if (!state.renderGraph)
    return (
      <div
        className={className}
        style={{
          height: '500px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          padding: '30px 46px',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#fff',
        }}>
        <BarLoader sizeUnit="px" size={250} color={palette.blue} />
      </div>
    );

  return (
    <Grid container spacing={2} className={className}>
      <Grid item lg={7} className="dash-card">
        <div className="card-heading">
          <h2 className="card-title">Usuarios </h2>
          <div className="dashboard-date-container">
            <DateRangePicker
              format="dd-MMM-yyyy"
              value={{ start: state.minDate, end: state.maxDate }}
              onChange={changedRangeInputs}
              max={maxDate}
            />
          </div>
          <button type="button" onClick={handleClick} style={{ background: 'transparent' }} ref={anchorEl}>
            <DotsVerticalRounded size={20} color="#232323" />
          </button>
          <Popup anchor={anchorEl.current} show={state.open} onOpen={onOpen} popupClass="popup-content">
            <div ref={contentRef} tabIndex={0} onFocus={onFocus} onBlur={onBlur}>
              <button type="button" onClick={handleCloseMenu}>
                <DownloadUsersReport filename={`ResumenCampus-${state.campus}`} companiesDataSet={state.campusUsers} />
              </button>
            </div>
          </Popup>
        </div>
        {state.renderGraph ? (
          <div className="vacancy-graph-container">
            <Grid container>
              {platform.platformCampus.length === 0 ? null : (
                <Grid item lg={4}>
                  <label className="graph-filter-label">Filtrar por campus / sede:</label>
                  <select
                    className="graph-filter-select"
                    value={state.campus}
                    onChange={(e) => {
                      const val = e.target.value;
                      setState((prev) => ({ ...prev, campus: val }));
                    }}>
                    <option value="all">General</option>
                    {platform.platformCampus.map((a) => {
                      return (
                        <option key={a} value={a}>
                          {a}
                        </option>
                      );
                    })}
                  </select>
                </Grid>
              )}
              <Grid item lg={4}>
                <label className="graph-filter-label">Filtrar por tipo:</label>
                <select
                  className="graph-filter-select"
                  value={state.typeUser}
                  onChange={(e) => {
                    const val = e.target.value;
                    setState((prev) => ({ ...prev, typeUser: val }));
                    filterByElse();
                  }}>
                  <option value="all">Todos</option>
                  <option value="Egresado">Egresados</option>
                  <option value="En curso">Estudiante</option>
                </select>
              </Grid>
              <Grid item lg={4}>
                <label className="graph-filter-label">Filtrar por carrera:</label>
                <select
                  className="graph-filter-select"
                  value={state.carrer}
                  onChange={(e) => {
                    const val = e.target.value;
                    setState((prev) => ({ ...prev, carrer: val }));
                    filterByElse();
                  }}>
                  <option value="all">General</option>
                  {platform.carrers.map((a) => {
                    return (
                      <option key={a} value={a}>
                        {a}
                      </option>
                    );
                  })}
                </select>
              </Grid>
            </Grid>
            <div className="graph-container" id="studients" />
          </div>
        ) : null}
      </Grid>

      <Grid item lg={4} className="dash-card">
        <div className="card-heading">
          <h2 className="card-title">Estadisticas</h2>
        </div>
        <div className="minicard-resume">
          <ShowChart size={24} className="decorative-icon-a" />
          <p className="minicard-d-result">{state.data[0]}</p>
          <p className="minicard-d-title">Total de usuarios registrados</p>
          <img
            src="https://lapieza-unis-admin-test.s3.us-west-1.amazonaws.com/static/media/img_1.dbe19b3c.png"
            alt=""
          />
        </div>
        <div className="minicard-resume">
          <ShowChart size={24} className="decorative-icon-a" />
          <p className="minicard-d-result">{state.data[1]}</p>
          <p className="minicard-d-title">Usuarios activos</p>
          <img
            src="https://lapieza-unis-admin-test.s3.us-west-1.amazonaws.com/static/media/linkedin.d72755cd.png"
            alt=""
          />
        </div>
        <div className="minicard-resume">
          <ShowChart size={24} className="decorative-icon-a" />
          <p className="minicard-d-result">{state.data[2]}</p>
          <p className="minicard-d-title">CV's subidos a plataforma</p>
          <img src={filed} alt="" />
        </div>
      </Grid>
    </Grid>
  );
}

export default styled(UsersDashboard)`
  width: 100%;
  font-family: 'Sofia Pro', sans-serif;
  margin-top: 64px;
  padding: 0 32px;
  .graph-filter-select {
    max-width: 90%;
  }
  .minicard-resume {
    display: grid;
    grid-template-columns: 1fr;
    padding: 32px;
    background-color: #f4f4f4;
    margin-bottom: 12px;
    border-radius: 8px;
    position: relative;
    p {
      margin: 0 !important;
      margin-bottom: 12px !important;
      z-index: 10 !important;
    }
    img {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 172px;
    }
    .minicard-d-result {
      font-size: 20px !important;
    }
    minicard-d-title {
      font-family: 'Cooper Md BT', serif !important;
    }
  }
  .dash-card {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    margin: 16px;
  }
  .card-heading {
    background-color: #fff;
    border-bottom: solid 2px #f9f9f9;
    width: 100%;
    padding: 12px;
    display: grid;
    grid-template-columns: 2fr 3fr 1fr;
    margin-bottom: 12px;
    min-height: 75px;
  }
  .card-title {
    color: #0f3f44;
    font-family: 'Cooper Md BT', serif;
    font-size: 16px;
    align-self: center;
  }
  .top-five-item {
    background-color: #859a9d;
    display: grid;
    grid-template-columns: 8fr 2fr;
    margin: 12px 0;
    border-radius: 8px;
    padding: 12px;
    p,
    .top-five-text,
    .top-five-count {
      color: #fff;
    }
    p {
      margin: 0 !important;
      color: #fff !important;
      font-size: 12px !important;
    }
    .top-five-text {
      font-family: 'Cooper Md BT', serif;
      font-size: 20px;
      text-transform: capitalize;
    }
    .top-five-count {
      color: #fff;
      font-size: 24px;
      align-content: center;
      align-self: center;
      align-items: center;
      margin-bottom: 8px;
      font-weight: 700;
      justify-self: center;
    }
  }
  label {
    margin-left: 16px;
    color: #26484e;
    margin-bottom: 8px;
  }
  select {
    padding: 8px 12px 8px 32px;
    border-radius: 8px;
    margin-left: 8px;
  }
  .analytics-loader-show {
    background-color: var(--white-color);
    width: 100%;
    padding: 0px;
    position: relative;
    top: 0;
    z-index: 9999;
    height: 90vh;
    margin-right: -36px;
    padding-left: 0px;
  }
  .analytics-loader-hide {
    position: fixed;
    left: 9999px;
  }
  .k-label {
    margin-left: 0;
  }
  .k-input {
    font-family: 'Sofia Pro', sans-serif;
  }
  .k-button {
    background: #0f3f44;
    border-color: #0f3f44;
  }

  .graph-filter-container {
    display: grid;
    grid-template-columns: 1fr;
    padding-top: 8px;
  }
  .graph-pre {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 24px 12px;
  }
  .graph-container {
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
    padding: 10px;
    height: 500px;
  }
  @media screen and (max-width: 1367px) {
    .minicard-d-title {
      padding: 0 50% 0 0 !important;
    }
  }
`;
